import {forkJoin } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { User } from '../../../shared/models';
import { FormGroup, FormBuilder, Validators, NgForm, FormControl, ValidationErrors } from '@angular/forms';
import { UserService } from '../../../shared/services';
import { UserRoleEnum } from '../../../shared/common/user-role.enum';
import { ToastyService } from 'ng2-toasty';
import { Association } from '../../../shared/models/association.model';
import { AssocUser } from 'app/shared/models/assoc-user.model';
@Component({
  selector: 'app-admin-edition',
  templateUrl: './admin-edition.component.html',
  styleUrls: ['./admin-edition.component.css']
})
export class AdminEditionComponent implements OnInit {

  public user: User;
  public userDetailsForm: FormGroup;
  public passwordForm: FormGroup;
  public isAssociation = false;
  public userType = '';
  public associations: Association[];

  constructor(private route: ActivatedRoute, private formBuilder: FormBuilder,
              private userService: UserService, private toastyService: ToastyService) {

    this.user = this.route.snapshot.data['user'];
    this.associations = this.route.snapshot.data['associations'];
    this.isAssociation = UserRoleEnum.ASSOCIATION === this.user.role.id;
    this.userType = this.isAssociation ? 'assoc_admins' : 'gand_admins';

    // tslint:disable-next-line:max-line-length
    const patternEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    this.userDetailsForm = formBuilder.group({
      'name': ['', [Validators.required]],
      'firstname': ['', [Validators.required]],
      'email': ['', [Validators.required, Validators.pattern(patternEmail)]],
      'alt_email': ['']
    });

    this.passwordForm = formBuilder.group({
      'password': [''],
      'password_confirmation': ['']
    }, { validator: this.checkIfMatchingPasswords('password', 'password_confirmation') });
  }

  ngOnInit() {
    if (this.isAssociation) {
      this.userDetailsForm.addControl('assoc', new FormControl(this.user.assoc_user.assoc_id, [Validators.required]));
      this.userDetailsForm.addControl('username', new FormControl(this.user.username, [Validators.required]));
      this.userDetailsForm.get('email').clearValidators();
      this.userDetailsForm.get('email').updateValueAndValidity();
    }

    this.userDetailsForm.patchValue({
      name: this.user.name,
      firstname: this.user.firstname,
      alt_email: this.user.alt_email
    });
  }

  save(): void {
    if (this.formsHaveChanges(this.userDetailsForm, this.passwordForm)) {
      this.validateAllFormFields(this.passwordForm);
      this.validateAllFormFields(this.userDetailsForm);

      let canPost = this.passwordForm.valid && this.userDetailsForm.valid;

      if (canPost) {
        const user: User = Object.assign(this.user, {
          email: this.userDetailsForm.value['email'],
          firstname: this.userDetailsForm.value['firstname'],
          name: this.userDetailsForm.value['name'],          
        });

        if (this.isAssociation){
          user.assoc_user = Object.assign(new AssocUser(), {
            assoc_id: this.userDetailsForm.value['assoc'],
            id: this.user.assoc_user.id
          });
          user.alt_email = this.userDetailsForm.value['alt_email'];
          user.username = this.userDetailsForm.value['username'];
        }

        // Observable
        forkJoin([
          this.userService.updatePassword(Object.assign(user, this.passwordForm.value)),
          this.userService.update(user)]).subscribe(
            (data) => {
              this.toastyService.success({
              title: 'F&eacute;licitation',
              msg: 'Utilisateur modifi&eacute; avec succ&egrave;s',
              showClose: true,
              timeout: 5000,
              theme: 'bootstrap',
            })},
            (err) => {
              console.error(err);
              let message = 'Une erreur s\'est produite';

              if (err && err.error && err.error.errors && err.error.errors[0].details) {
                message = err.error.errors[0].details;
              }

              this.toastyService.error({
              title: 'Attention',
              msg: message,
              showClose: true,
              timeout: 5000,
              theme: 'bootstrap',
            })});
      } else {
        this.toastyService.error({
          title: 'Attention',
          msg: 'Merci de corriger les erreurs',
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        });
      }
    } else {
      this.toastyService.error({
        title: 'Attention',
        msg: 'Pas de changement detect&eacute;',
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      });
    }
  }

  /**
   * Validate all FormControl
   * @param formGroup FormGroup instance
   */
  private validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  private checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      const passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({ notEquivalent: true });
      } else {
        return passwordConfirmationInput.setErrors(null);
      }
    };
  }

  private move(array: any[], from: number, to: number) {
    array.splice(to, 0, array.splice(from, 1)[0]);
    return array;
  };

  private formsHaveChanges(...forms: FormGroup[]): boolean {
    let result = false;
    forms.forEach(form => {
      if (!!form && form.dirty) {
        result = true;
      }
    })
    return result;
  }
}
